import { Skeleton, Stack } from "@mui/material";
import type { FC } from "react";

type Props = {
	hasDivider: boolean;
};

export const GoalDetailSolutionItemSkeleton: FC<Props> = ({ hasDivider }) => (
	<Stack
		direction="row"
		alignItems="center"
		gap={1}
		width="100%"
		px={1.6}
		py={1.4}
		borderBottom={hasDivider ? 1 : 0}
		borderColor="surface.border"
	>
		<Stack flex={1} minWidth={0} gap={0.4}>
			<Skeleton variant="text" width="45%" height={18} animation="wave" />
			<Skeleton variant="text" width="60%" height={14} animation="wave" />
			<Skeleton
				variant="text"
				width="35%"
				height={14}
				animation="wave"
				sx={{ mt: 0.4 }}
			/>
		</Stack>
		<Skeleton
			variant="circular"
			width={16}
			height={16}
			sx={{ flexShrink: 0 }}
			animation="wave"
		/>
	</Stack>
);
